import axios from "axios";
import { API_URL, getAuthHeader } from ".";
import {
  CustomerInvoiceDetail,
  CustomerInvoiceSummary,
} from "../Models/CustomerInvoice";

class CustomerInvoiceApi {
  static getMyInvoices(skip = 0, take = 50) {
    return axios.get<CustomerInvoiceSummary[]>(
      `${API_URL}/api/customer-invoices?skip=${skip}&take=${take}`,
      getAuthHeader()
    );
  }

  static getInvoiceByNumber(invoiceNumber: number) {
    return axios.get<CustomerInvoiceDetail>(
      `${API_URL}/api/customer-invoices/by-number/${invoiceNumber}`,
      getAuthHeader()
    );
  }
}

export default CustomerInvoiceApi;
